import React, { useState,useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

//SimpleBar
import SimpleBar from "simplebar-react";

import { baseURL, submitOrder } from '../../utils/order';
import { createSelector } from 'reselect';
import { fetchCartList ,modifyCartItem} from '../../utils/cart';
//import images
import image1 from "../../assets/images/products/img-1.png";
import image2 from "../../assets/images/products/img-2.png";
import image3 from "../../assets/images/products/img-3.png";
import image6 from "../../assets/images/products/img-6.png";
import image5 from "../../assets/images/products/img-5.png";
import { ToastContainer, toast } from 'react-toastify';
import EventBus from '../../utils/eventBus'; // 引入 EventBus


const MyCartDropdown = () => {
    // const cartData = [
    //     { id: 1, img: image1, product: "Branded T-Shirts", quantity: 10, price: 32 },
    //     { id: 2, img: image2, product: "Bentwood Chair", quantity: 5, price: 18 },
    //     { id: 3, img: image3, product: "Borosil Paper Cup", quantity: 3, price: 250 },
    //     { id: 4, img: image6, product: "Gray Styled T-Shirt", quantity: 1, price: 1250 },
    //     { id: 5, img: image5, product: "Stillbird Helmet", quantity: 2, price: 495 },
    // ];
    
  const [cartList, setCartList] = useState(null);
    const [isCartDropdown, setIsCartDropdown] = useState(false);

    const [cartItem, setCartItem] = useState(cartList?.length ||0);

    const [subTotal, setSubTotal] = useState(0);
      // const [loading, setLoading] = useState(true);
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const successnotify = (message) => toast(message, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });
  


    const toggleCartDropdown = () => {
        setIsCartDropdown(!isCartDropdown);
    };

    useEffect(() => {
        const handleRefresh = () => { 
            console.log('ComponentB: 收到刷新事件，重新加载数据');
            loadCartListData();
        };
    
        // 订阅事件
        EventBus.subscribe('refresh', handleRefresh);
    
        // 组件卸载时取消订阅
        return () => {
            EventBus.unsubscribe('refresh', handleRefresh);
        };
    }, []);

    useEffect(() => {
   
      loadCartListData();
    }, []);

    const loadCartListData = async () => {
        try { 
          const response = await fetchCartList();  
          if (response.status === 200){ 
            console.log(response.data) 
            setCartList(response.data);
            updateOrderSummary(response.data);
            setCartItem(response.data?response.data.cart_items.length : 0);
          }
          else{
            errornotify(response.message)
          }
        } catch (error) {
          console.error("Error loading cartlist:", error);
        } finally {
          // setLoading(false);
        }
    }; 
 
    function removeCartItem(id, quantity) { 
        handleCartUpdate({'id': id, 'add': 0, 'reduce': quantity,remove: true});
      }
      
  
  const handleCartUpdate = async (values) => {
    try {   
      // Make API call with error handling
      const modify_response = await modifyCartItem(values); 
      if (modify_response.status==200) {  
          // Fetch updated cart data after modifying an item
          const id = modify_response.data.cart_item.id
          cartList.cart_items.map((item,index) => {
            if (values.remove&&item.id === id){

              var filteredCart = cartList.cart_items.filter(cartitem => cartitem.id!==  id);
              cartList.cart_items = filteredCart; 
              console.log(cartList);
            }else if(!values.remove&&item.id === id){
              item.quantity = modify_response.data.cart_item.quantity 
            }else{ 
              return item;
            }
            
        });   
        updateOrderSummary(cartList);
           
      }
      else{
        errornotify(modify_response.message)
      }
  
    } catch (err) {
      console.error('Submission failed:', err);

    }
  };
    const updateOrderSummary = (cartData) => {
        if (!cartData || !cartData.cart_items) return;
  
        const newSubTotal = cartData.cart_items.reduce(
            (acc, item) => acc + (item.edition.price * item.quantity), 0
        );
        
        // Round to 2 decimal places to avoid floating point precision issues
        const roundedSubTotal = Math.round(newSubTotal * 100) / 100;
        setSubTotal(roundedSubTotal.toFixed(2)); 
    };
    const removeItem = (cartItemId, quantity) => {
        removeCartItem(cartItemId, quantity);
        // Update cart item count after removal
        setCartItem(prev => prev - 1);
    };
    return (
        <React.Fragment>
        <ToastContainer />
            <Dropdown isOpen={isCartDropdown} toggle={toggleCartDropdown} className="topbar-head-dropdown ms-1 header-item">
                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                    <i className='bx bx-cart fs-22'></i>
                    <span
                        className="position-absolute topbar-badge translate-middle badge rounded-pill bg-info">{cartItem}<span
                            className="visually-hidden">unread messages</span></span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-xl dropdown-menu-end p-0"
                    aria-labelledby="page-header-cart-dropdown">
                    <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                        <Row className="align-items-center">
                            <Col>
                                <h6 className="m-0 fs-16 fw-semibold"> My Cart</h6>
                            </Col>
                            <div className="col-auto">
                                {cartList && cartList.cart_items && cartList.cart_items.length > 0 ? (
                                  <span className="badge bg-warning-subtle text-warning fs-13"> 
                                    <span className="cartitem-badge">{cartItem}</span> items
                                  </span>
                                ) : (
                                  <span className="badge bg-secondary-subtle text-secondary fs-13">0 items</span>
                                )}
                            </div>
                        </Row>
                    </div>
                    <SimpleBar style={{ maxHeight: "300px" }}>
                        <div className="p-2">
                            {(!cartList || !cartList.cart_items || cartList.cart_items.length === 0) ? (
                              <div className="text-center empty-cart">
                                <div className="avatar-md mx-auto my-3">
                                    <div className="avatar-title bg-info-subtle text-info fs-36 rounded-circle">
                                        <i className='bx bx-cart'></i>
                                    </div>
                                </div>
                                <h5 className="mb-3">Your Cart is Empty!</h5>
                                <Link to="/product-list" className="btn btn-success w-md mb-3">Shop Now</Link>
                              </div>
                            ) : (
                              cartList.cart_items.map((cartItem, key) => (
                                <div className="d-block dropdown-item text-wrap dropdown-item-cart px-3 py-2" key={key}>
                                  <div className="d-flex align-items-center">
                                      <img   src={
                                          cartItem.edition && 
                                          cartItem.edition.images && 
                                          cartItem.edition.images.length > 0
                                              ? baseURL + "/file/product/image/" + cartItem.edition.images[0].image_url
                                              : baseURL + "/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp"
                                      }
                                          className="me-3 rounded-circle avatar-sm p-2 bg-light" 
                                          alt={cartItem.product?.name || "Product"} 
                                          onError={(e) => {
                                              e.target.src = baseURL + "/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp";
                                              e.target.onerror = null; // Prevent infinite loop
                                          }}
                                      />
                                      <div className="flex-grow-1">
                                          <h6 className="mt-0 mb-1 fs-14">
                                              <Link  to={"/product-detail?productId="+cartItem.id}   className="text-reset"> {cartItem.product?.name || "Product"}</Link>
                                          </h6>
                                          <p className="mb-0 fs-12 text-muted">
                                              Quantity: <span>{cartItem.quantity} x ${cartItem.edition?.price?.toFixed(2) || "0.00"}</span>
                                          </p>
                                      </div>
                                      <div className="px-2">
                                          <h5 className="m-0 fw-normal">$<span className="cart-item-price">{(cartItem.quantity * (cartItem.edition?.price || 0)).toFixed(2)}</span></h5>
                                      </div>
                                      <div className="ps-2">
                                          <button type="button" className="btn btn-icon btn-sm btn-ghost-secondary remove-item-btn"   onClick={() => removeCartItem(cartItem.id, cartItem.quantity)}><i
                                              className="ri-close-fill fs-16"></i></button>
                                      </div>
                                  </div>
                                </div>
                              ))
                            )}
                        </div>
                    </SimpleBar>
                    {cartList && cartList.cart_items && cartList.cart_items.length > 0 && (
                      <div className="p-3 border-bottom-0 border-start-0 border-end-0 border-dashed border" id="checkout-elem">
                          <div className="d-flex justify-content-between align-items-center pb-3">
                              <h5 className="m-0 text-muted">Total:</h5>
                              <div className="px-2">
                                  <h5 className="m-0">$<span id="cart-item-total">{subTotal}</span></h5>
                              </div>
                          </div>

                          <Link to="/check-out" className="btn btn-success text-center w-100">
                            Checkout
                          </Link>
                      </div>
                    )}
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default MyCartDropdown;